import React from 'react';
import { mergeClassNames } from '../../../../../utils';
import Label from './Label';
import WarningLabel from './WarningLabel';
import styles from './index.module.scss';

export function InputLabels({
  caption = '',
  id = caption,
  htmlFor,
  children,
  required = false,
  validated = false,
  invalid = false,
  setActive = () => null,
  isActive = false,
  className = null,
  style = null,
}) {
  return (
    <div
      id={id}
      className={mergeClassNames([
        styles.inputOuter,
        validated ? styles.validated : null,
        invalid ? styles.inputError : null,
        isActive ? styles.active : null,
        className,
      ])}
      style={style}
      onClick={setActive}
    >
      <Label htmlFor={htmlFor} required={required}>
        {caption}
      </Label>
      {children}
      {invalid ? <WarningLabel caption="Field required" /> : null}
    </div>
  );
}
